// добавление в сравнение
$(".add-to-confirm").on("click", function() {
    let $this = $(this),
        id = $this.data('id'),
        iblockid = $this.data('iblockid')

    if($this.hasClass('added')){
        Compare.methods.del(id, iblockid);
        $this.removeClass('added');
        $this.text('Добавить в сравнение');
    } else {
        Compare.methods.add(id, iblockid);
        $this.addClass('added');
        $this.text('Добавлено в сравнение');
    }
});


// добавление в корзину
// $(".buy-product").on("click", function() {
//     let $this = $(this),
//         id = $this.data('id'),
//         quant = $this.data('quant');
//
//     Basket.methods.add($this, id, quant);
// });

$(".remove-product").on("click", function() {
    let $this = $(this),
        id = $this.data('id');

    $.ajax({
        url: window.SITE_DIR + 'ajax.php',
        data: {
            'id': id,
            'action': 'delFromBasket',
        },
        type: 'post',
        dataType: 'json',
        success: function(response){
            $('.mini-basket .count').text(response.count);
            location.reload();
        }
    });
});

// обновление корзину
$(".js-count").on("change", function() {
    let $this = $(this),
        id = $this.data('id'),
        quant = $this.val();
    const max = $this.attr('data-max');
    // alert(max);
    console.log(quant, max);
    if (quant > max ) {

            $this.closest('tr')
                .find('.quantity-of-goods-1')
                .addClass('active');
            $this.val(max);

        return;
    }

    Basket.methods.changeQuantity(id, quant);
});

// удалить из корзины
$(".js-remove").on("click", function() {
    let $this = $(this),
        id = $this.data('id');

    Basket.methods.del(id);
});

// добавление в избраное
$(".add-to-wish").on("click", function() {
    let $this = $(this),
        id = $this.data('id');

    if($this.hasClass('added')){
        Like.methods.del(id);
        $this.removeClass('added');
        if (window.location.href.indexOf("favorites") != '-1')
        {
            $('.el-'+id).remove();
            var el = $(".products-list").children().length;
            $(".found b").html(el + " позиций");
            if ( el < 1)
            {
                $('.top-ctrl').remove();
                $('.page-title').after(function() {
                    return 'У вас нет избраных';
                });
            }
        }
    } else {
        Like.methods.add(id);
        $this.addClass('added');
    }
});

// изменить количество на детальной
$(".js-quantity").on("change", function() {
    let $this = $(this);
    var value = $this.val();
    $('.buy-product').each(function(i, val){
        val.dataset.quant = value;
    });
});

//отправка формы регистрации
$("#registerBuyer").submit(function(e) {
    e.preventDefault();
    var form = $(this);
    var url = form.attr('action');
    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function(data)
        {
        }
    });
});

$('body').on('input', '.personal-city', function(){
    this.value = this.value.replace(/[^a-zа-яё\s]/gi, '');
});

$(document).on('click', '.faq-block-header', function ({target}) {
    const $wrapper = $(target).closest('.faq-block');
    // console.log($wrapper.hasClass('active'));

    if (!$wrapper.hasClass('active')) {
        $wrapper.find('.faq-block-main').slideDown();
    } else {
        $wrapper.find('.faq-block-main').slideUp();
    }
    $wrapper.toggleClass('active');
});